import history from '../../../../history';
import { extractDataFromArray, extractNameFromArray, showFormatedDate, showFormattedTime, showFormatedDateandTime, alertConfirmation, CBG } from '../../../../actions/utilAction';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { createClaimAction, getAppointmentById, getMasterData, getSoapAction, saveEncounterSigns, savePatientSoapAction, updateServiceCodeBlockedUnits, saveClockInTimeIntoAppointment } from './actions/soapActions';
import { getPatientProfileDetails } from '../../../patients/actions/PatientActions';
import React, { Component } from 'react';
import { renderTextArea, renderCheckBox, renderTimePicker, renderTextField, renderCustomRadioButtons, isInteger } from '../../../../components/reduxFields';
import { CancelButton, CommonButton } from '../../../../components/buttons';
import { getAppConfigList, getGeoLocation, getGeoLocationClockIn } from '../../../AppConfig/actions';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import classNames from 'classnames';
import { connect } from 'react-redux';
import moment from 'moment';
import PatientInfo from '../../../patients/patient_info';
import ProblemModal from './soap_daignosisModal';
import CPTModal from './soap_CPTModal';
import SignatureModal from './signature_modal';
import SignatureWithRenderingProviderModal from './signatureWithRenderingProvider_modal';
import Alert from 'react-s-alert';
import validate from './validate';


//const validateNotes = (value) => !value ? 'Please enter notes.' : undefined;

class ProgressNotes_CAS extends Component {
  constructor(props) {
    super(props);
    this.state = ({
      fixedHeader: true,
      height: '200px',
      selectable: false,
      fixedFooter: false,
      DateTimeOfVisit: '',
      patientObj: [],
      master_data: props.master_data,
      firstName: '',
      middleName: '',
      lastName: '',
      fullName: '',
      patient_id: null,
      apptid: parseInt(props.match.params.apptId, 10),
      encounterId: parseInt(props.match.params.encId, 10),
      isAdminUpdateAfterRendered: parseInt(props.match.params.isAdminUpdate, 10),
      isGenerateClaimAfterRendered: parseInt(props.match.params.isGenerateClaim, 10),
      staffID: null,
      renderingProviderID: null,
      renderingProviderName: '',
      appointmentDate: '',
      appointmentTime: '',
      staffName: '',
      patientName: '',
      appointmentTypeName: '',
      payerName: '',
      appointmentTypeIsBillable: false,
      serviceFacility: '',
      isDirectService: false,
      genderID: null,
      diagnosisArray: [],
      PatientLocationID: null,
      PatientLocationName: '',
      open: false,
      openCPT: false,
      openSign: false,
      soapPage: false,
      attachment: [],
      icdArray: [],
      DateOfService: '',
      master_CPT: props.master_data.masterCPT ? props.master_data.masterCPT : [],
      attachedDiagnosisArray: [],
      get_soap: null,
      serviceStartTime: '',
      serviceEndTime: '',
      appointment: null,
      ParentAppointmentID: null,
      appointmentStartDateTime: '',
      appointmentEndDateTime: '',
      CPTTableData: [],
      EmployeeSign: { id: 0, Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      ClientSign: { id: 0, Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      GuardianSign: { id: 0, Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      RenderingProviderSign: { id: 0, Bytes: '', Date: null, Name: '', Latitude: 0.0, Longitude: 0.0 },
      signRequired: {
        employee_sign: false,
        client_sign: false,
        guardian_sign: false,
        rederingProvider_sign: false,
      },
      showCompleteButton: false,
      isAllSigned: false,
      isSoapCompleted: false,
      signatureStaffs: [],
      signatureRenderingProviders: [],
      // isAdminUpdateAfterRendered: false,

      // checkbox handling
      isParentReportCheckAllowed: true,
      isSymptomsObservedAllowed: true,
      isTreatmentGoalsAllowed: true,
      isGeneralizationAllowed: true,
      isBehaviorReductionAllowed: true,
      isProtocolModificationAllowed: true,
      isBTGuidanceAllowed: true,
      IsWarrantTherapy: null,
      clockInDateTime: '',
    });
    this.filter = {
      isClientSigned: false,
      isEmployeeSigned: false,
      isGuardianSigned: false,
      isRenderingProviderSigned: false,
    };
    this.onDateChange = this.onDateChange.bind(this);
    this.renderDiagnosis = this.renderDiagnosis.bind(this);
    this.renderCpt = this.renderCpt.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onCompleteSoap = this.onCompleteSoap.bind(this);
    this.changeIsWarrantTherapy = this.changeIsWarrantTherapy.bind(this);
    this.handleClockIn = this.handleClockIn.bind(this);
  };

  componentWillMount() {
    this.props.getMasterData();
    // this.props.getPatientDetailsById(this.state.patient_id);
    if (this.state.apptid) {
      // this.props.getAppointmentById(this.state.apptid);
      let isAdminUpdateAfterRendered = this.state.isAdminUpdateAfterRendered ? true : false;
      this.props.getSoapAction(this.state.apptid, this.state.encounterId, isAdminUpdateAfterRendered);
    }
    this.props.getAppConfigList();
  }

  handleCancel() {
    history.push('/scheduling');
  }

  handleAlertClick = (event) => {
    this.setState({clockInDateTime : moment.utc().format('YYYY-MM-DDTHH:mm:ss')},()=>{ this.props.getGeoLocationClockIn(); });    
    Alert.closeAll();
  };

  handleClockIn = (event) => {
    let warningMsg = 'Are you sure you want to clock-in ? You can only do it once. You should be at the location where session is taking place';
    alertConfirmation(warningMsg, {
      html: true,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertClick       
      },
    });
  };

  formatedSoapData(soapDetail) {
    if (soapDetail) {
      let soapObj = soapDetail.data;
      // bind appointment data .....
      let appointmentData = soapObj.patientAppointment;
      let staffIds = [];
      let staffNames = [];
      let signatureStaffs = [];
      appointmentData.appointmentSingleStaff.forEach((staff) => {
        staffNames.push(staff.staffName);
        staffIds.push(staff.staffId);
        signatureStaffs.push({ 'id': staff.staffId, 'value': staff.staffName });
      });
      
      let renderingProviderIds = [];
      let renderingProviderNames = [];
      let signatureRenderingProviders = [];      

      appointmentData.appointmentRenderingProviders.forEach((staff) => {
        renderingProviderNames.push(staff.renderingProviderName);
        renderingProviderIds.push(staff.renderingProviderId);
        signatureRenderingProviders.push({ 'id': staff.renderingProviderId, 'value': staff.renderingProviderName });
      });

      let staffID = staffIds && staffIds.length ? staffIds[0] : null;
      let staffName = staffNames && staffNames ? staffNames.join(',') : '';
      let renderingProviderID = renderingProviderIds && renderingProviderIds.length ? renderingProviderIds[0] : null;
      let renderingProviderName = renderingProviderNames && renderingProviderNames ? renderingProviderNames.join(',') : '';
      let appointmentTypeName = appointmentData.appointmentTypeName;
      let payerName = appointmentData.payerName;
      let appointmentTypeIsBillable = appointmentData.isBillable;
      let appointmentDate = showFormatedDate(appointmentData.dateOfService);
      let appointmentTime = showFormattedTime(appointmentData.startDateTime) + ' - ' + showFormattedTime(appointmentData.endDateTime);
      let patientName = appointmentData.patientName;
      // let appointmentTime = `${formattedStartTimehours}:${appointmentData.StartDateTime.substr(14, 2)} ${AmPmOfStartTime} - ${formattedEndTimehours}:${appointmentData.EndDateTime.substr(14, 2)} ${AmPmOfEndTime}`;
      let PatientLocationID = '';
      let PatientLocationName = appointmentData.address;
      if (!appointmentTypeIsBillable) {
        this.setState({ isAllSigned: true });
      }
      // to get the patient info panel ..
      if (appointmentData.patientID) {
        this.props.getPatientProfileDetails(appointmentData.patientID);
      }

      this.setState({
        appointment: appointmentData,
        ParentAppointmentID: appointmentData.parentAppointmentId,
        staffID: staffID,
        staffName: staffName,
        renderingProviderID: renderingProviderID,
        renderingProviderName: renderingProviderName,
        patient_id: appointmentData.patientID,
        patientName: patientName,
        appointmentTypeName: appointmentTypeName,
        payerName: payerName,
        appointmentTypeIsBillable: appointmentTypeIsBillable,
        appointmentDate: appointmentDate,
        appointmentTime: appointmentTime,
        DateTimeOfVisit: `${appointmentDate}, ${appointmentTime}`,
        PatientLocationName: PatientLocationName,
        PatientLocationID: PatientLocationID,
        DateOfService: appointmentData.startDateTime,
        appointmentStartDateTime: appointmentData.startDateTime,
        appointmentEndDateTime: appointmentData.endDateTime,
        serviceStartTime: appointmentData.startDateTime,
        serviceEndTime: appointmentData.endDateTime,
        showCompleteButton: appointmentTypeIsBillable && this.state.encounterId ? true : false,
        signatureStaffs: signatureStaffs,
        signatureRenderingProviders: signatureRenderingProviders,
        serviceFacility: appointmentData.serviceFacility,
        isDirectService: appointmentData.isDirectService,
        isAdminUpdateAfterRendered: (appointmentData.claimId && appointmentData.canEdit),
        clockInDateTime: appointmentData.clockInDateTime,
      }, () => {
        if (soapObj.id && !(this.state.isAdminUpdateAfterRendered && this.props.modifyAfterRenderPermission)) {
          // this.setState({
          //   serviceStartTime: soapObj.startDateTime,
          //   serviceEndTime: soapObj.endDateTime,
          // });
        }
        let icdArray = [];
        if (soapObj.patientEncounterDiagnosisCodes && soapObj.patientEncounterDiagnosisCodes.length) {
          soapObj.patientEncounterDiagnosisCodes.forEach((obj, index) => {
            icdArray.push({
              'DiagnosisDate': moment(obj.diagnosisDate).format(),
              'Description': obj.description,
              'ICDCodeId': obj.icdCodeId,
              'ICDCode': obj.icdCode,
              'IsDeleted': obj.isDeleted,
              'Id': obj.id,
            });
          });
          this.setState({
            diagnosisArray: icdArray,
          });
        }
        let cptArray = [];
        if (soapObj.patientEncounterServiceCodes && soapObj.patientEncounterServiceCodes.length) {
          soapObj.patientEncounterServiceCodes.forEach((obj, index) => {
            cptArray.push({
              'AuthProcedureCPTLinkId': obj.authProcedureCPTLinkId,
              'AuthorizationNumber': obj.authorizationNumber,
              'ServiceCodeId': obj.serviceCodeId,
              'ServiceCode': obj.serviceCode,
              'Description': obj.description,
              'IsDeleted': obj.isDeleted,
              'Id': obj.id,
              'Modifier1': obj.modifier1,
              'Modifier2': obj.modifier2,
              'Modifier3': obj.modifier3,
              'Modifier4': obj.modifier4,
              'AttachedModifiers': obj.attachedModifiers,
            });
          });
        }
        if (soapObj.encounterSignature) {
          (soapObj.encounterSignature || []).forEach((signObj) => {
            if (signObj.guardianSign) {
              let data = {
                id: signObj.id,
                Bytes: signObj.guardianSign,
                Date: signObj.guardianSignDate,
                Name: signObj.guardianName,
                Latitude: signObj.latitude,
                Longitude: signObj.longitude,
              };
              this.filter.isGuardianSigned = true;
              this.setState({ GuardianSign: data });
            }
            if (signObj.patientSign) {
              let data = {
                id: signObj.id,
                Bytes: signObj.patientSign,
                Date: signObj.patientSignDate,
                Name: this.state.patientName,
                Latitude: signObj.latitude,
                Longitude: signObj.longitude,
              };
              this.filter.isClientSigned = true;
              this.setState({ ClientSign: data });
            }
            if (signObj.clinicianSign) {
              let data = {
                id: signObj.id,
                Bytes: signObj.clinicianSign,
                Date: signObj.clinicianSignDate,
                Name: this.state.staffName,                
                Latitude: signObj.latitude,
                Longitude: signObj.longitude,
              };
              this.filter.isEmployeeSigned = true;
              this.setState({ EmployeeSign: data });
            }
            if (signObj.renderingProviderSign) {
              let data = {
                id: signObj.id,
                Bytes: signObj.renderingProviderSign,
                Date: signObj.renderingProviderSignDate,
                //Name: this.state.renderingProviderName,
                Name: signObj.renderingProviderName,
                Latitude: signObj.latitude, 
                Longitude: signObj.longitude,
              };
              this.filter.isRenderingProviderSigned = true;
              this.setState({ RenderingProviderSign: data });
            }    
          });
        }
        if ((soapObj.status || '').toLowerCase() === 'rendered') {
          if (this.state.isAdminUpdateAfterRendered !== undefined && !(this.state.isAdminUpdateAfterRendered && this.props.modifyAfterRenderPermission)) {
            this.setState({ isSoapCompleted: true, isAllSigned: true });
          } else {
            this.setState({ isAllSigned: true });
          }
        }
        if (!this.filter.isGuardianSigned) {
          let employee_signRequired = this.state.signRequired.employee_sign,
            client_signRequired = this.state.signRequired.client_sign,
            guardian_signRequired = this.state.signRequired.guardian_sign,
            rederingProvider_signRequired = this.state.signRequired.rederingProvider_sign;
          if (appointmentData && !appointmentData.isDirectService && this.state.signRequired.guardian_sign) {
            guardian_signRequired = this.props.requiredGuardianSignForIndirectServicePermission ? true : false;
          }

          this.setState({
            signRequired: {
              employee_sign: employee_signRequired,
              client_sign: client_signRequired,
              guardian_sign: guardian_signRequired,
              rederingProvider_sign: rederingProvider_signRequired,
            },
          }, () => {
            this.setState({
              isAllSigned: this.checkIsAllRequiredSigned(),
            });
          });
        }
        this.setState({
          isAllSigned: this.checkIsAllRequiredSigned(),
          get_soap: soapDetail.data,
          CPTTableData: cptArray,
          diagnosisArray: icdArray,
        },()=>{
          if(this.state.isGenerateClaimAfterRendered)
          {     
            var link = document.getElementById('btnComplete');      
            if(link)      
              link.click();            
          }
        });
      });
    }
  }
  componentWillReceiveProps(nextProps) {

    if (nextProps.match.params.encId !== this.props.match.params.encId) {
      let isAdminUpdateAfterRendered = this.state.isAdminUpdateAfterRendered ? true : false;
      this.props.getSoapAction(this.state.apptid, this.state.encounterId, isAdminUpdateAfterRendered);
    }

    if (nextProps.master_data && this.props.master_data !== nextProps.master_data) {
      this.setState({
        master_data: nextProps.master_data,
        master_CPT: nextProps.master_data.masterCPT,
      });
    }
    if (nextProps.app_config && this.props.app_config !== nextProps.app_config) {
      let app_config = nextProps.app_config;
      let employee_signRequired = false;
      let client_signRequired = false;
      let guardian_signRequired = false;
      let rederingProvider_signRequired = false;
      if (app_config && app_config.length) {
        app_config.forEach((Obj) => {
          if (Obj.configType === 1) {
            switch (Obj.key) {
              case 'CLINICIAN_SIGN':
                employee_signRequired = (Obj.value.toString().toLowerCase() === 'true');
                break;
              case 'PATIENT_SIGN':
                client_signRequired = (Obj.value.toString().toLowerCase() === 'true');
                break;
              case 'GUARDIAN_SIGN':
                guardian_signRequired = (Obj.value.toString().toLowerCase() === 'true');
                break;
              case 'RENDERINGPROVIDER_SIGN':
                rederingProvider_signRequired = (Obj.value.toString().toLowerCase() === 'true');
                break;
              default:
                break;
            }
          }
        });
      }

      if (!this.filter.isGuardianSigned) {
        // let isAnySignRequired = employee_signRequired || client_signRequired || guardian_signRequired;
        let patientAppointmentData = this.state.get_soap && this.state.get_soap.patientAppointment;
        // let isAppointmentRendered = this.state.get_soap && (this.state.get_soap.status || '').toLowerCase() === 'rendered';
        if (patientAppointmentData && !patientAppointmentData.isDirectService && guardian_signRequired) {
          guardian_signRequired = this.props.requiredGuardianSignForIndirectServicePermission ? true : false;
        }
        this.setState({
          // isAllSigned: !isAnySignRequired,
          signRequired: {
            employee_sign: employee_signRequired,
            client_sign: client_signRequired,
            guardian_sign: guardian_signRequired,
            rederingProvider_sign: rederingProvider_signRequired,
          },
        }, () => {
          this.setState({
            isAllSigned: this.checkIsAllRequiredSigned(),
          });
        });
      }
    }

    if (nextProps.saved_soap && this.props.saved_soap !== nextProps.saved_soap) {
      if (nextProps.saved_soap.id) {
        if (!this.state.encounterId) {
          history.push(`/progress-note-one/${this.state.apptid}/${nextProps.saved_soap.id}/${this.state.isAdminUpdateAfterRendered ? 1 : 0}/0`);
        } else {
          this.setState({ isSoapCompleted: true });
        }
        this.setState({ encounterId: nextProps.saved_soap.id, showCompleteButton: this.state.appointmentTypeIsBillable ? true : false });
      }
    }
    
    if(this.props.match.params.encId > 0 && nextProps.IsWarrantTherapy !== this.props.IsWarrantTherapy){      
       this.setState({IsWarrantTherapy: nextProps.IsWarrantTherapy || 0 },()=>{this.changeIsWarrantTherapy(null,nextProps.IsWarrantTherapy || 0)});      
    }

    if (nextProps.get_soap && this.props.get_soap !== nextProps.get_soap) {
      this.formatedSoapData(nextProps.get_soap);
    }

    if (nextProps.saved_EncounterSigns && nextProps.saved_EncounterSigns !== this.props.saved_EncounterSigns) {
      let signObj = nextProps.saved_EncounterSigns.data;
      if (signObj.guardianSign) {
        let data = this.state.GuardianSign;
        data.id = signObj.id;
        this.setState({ GuardianSign: data });
      }
      if (signObj.patientSign) {
        let data = this.state.ClientSign;
        data.id = signObj.id;
        this.setState({ ClientSign: data });
      }
      if (signObj.clinicianSign) {
        let data = this.state.EmployeeSign;
        data.id = signObj.id;
        this.setState({ EmployeeSign: data });
      }
      if (signObj.renderingProviderSign) {
        let data = this.state.RenderingProviderSign;
        data.id = signObj.id;
        this.setState({ RenderingProviderSign: data });
      }
    }

    if (nextProps.clockInLatitude && nextProps.clockInLatitude > 0 && this.props.clockInLatitude !== nextProps.clockInLatitude) {
      let formData = {
        'appointmentId': this.state.apptid,
        'clockInDateTime': this.state.clockInDateTime,
        'clockInLatitude' : nextProps.clockInLatitude || 0.0,
        'clockInLongitude' : nextProps.clockInLongitude || 0.0,
      }
      this.props.saveClockInTimeIntoAppointment(formData);
    }

  };

  onDateChange(input, value) {
    input.onChange(moment(value).format());
    this.setState({ [input.name]: value });
  };

  onCompleteSoap(formProps) {
    this.setState({ isGenerateClaimAfterRendered: false });
    let isGenerateClaim = true;
    this.submitFormData(formProps, isGenerateClaim);
  }

  onSubmit(formProps) {
    this.submitFormData(formProps);
  };

  submitFormData(formProps, isGenerateClaim = false) {
    if (!this.state.diagnosisArray.filter((Obj) => !Obj.IsDeleted).length) {
      Alert.warning('Please add atleast one diagnosis!', {
        position: 'bottom-right',
        effect: 'slide',
      });
      return false;
    }
    if (this.state.appointmentTypeIsBillable) {
      if (!this.state.CPTTableData.filter((Obj) => !Obj.IsDeleted).length) {
        Alert.warning('Please add atleast one service code!', {
          position: 'bottom-right',
          effect: 'slide',
        });
        return false;
      }
    }

    let ICDArray = this.state.diagnosisArray;
    let CPTcodes = this.state.CPTTableData;
    let formData = {
      'Id': this.state.encounterId,
      'PatientID': this.state.patient_id,
      'AppointmentStartDateTime': this.state.appointmentStartDateTime,
      'AppointmentEndDateTime': this.state.appointmentEndDateTime,
      'PatientAppointmentId': this.state.encounterId || !this.state.appointment.RecurrenceRule ? this.state.apptid : null,
      'ParentAppointmentId': this.state.encounterId ? null : this.state.ParentAppointmentID,
      'DateOfService': this.state.DateOfService,
      'StartDateTime': moment(this.state.serviceStartTime).format('YYYY-MM-DD') + 'T' + moment(this.state.serviceStartTime).format('HH:mm:ss'),
      'EndDateTime': moment(this.state.serviceEndTime).format('YYYY-MM-DD') + 'T' + moment(this.state.serviceEndTime).format('HH:mm:ss'),
      'StaffID': this.state.staffID,
      // 'LocationID': this.props.singleEncounter.locationID,
      'ServiceLocationID': this.state.appointment ? this.state.appointment.serviceLocationID : null,
      'OfficeAddressID': this.state.appointment ? this.state.appointment.officeAddressID : null,
      'PatientAddressID': this.state.appointment ? this.state.appointment.patientAddressID : null,
      'CustomAddressID': this.state.appointment ? this.state.appointment.customAddressID : null,
      'CustomAddress': this.state.appointment ? this.state.appointment.customAddress : null,
      'ServiceAddress': this.state.appointment ? this.state.appointment.address : null,
      // 'PatientSign': this.state.ClientSign.Bytes,
      // 'PatientSignDate': this.state.ClientSign.Date,
      // 'ClinicianSign': this.state.EmployeeSign.Bytes,
      // 'ClinicianSignDate': this.state.EmployeeSign.Date,
      // 'GuardianSign': this.state.GuardianSign.Bytes,
      // 'GuardianSignDate': this.state.GuardianSign.Date,
      // 'GuardianName': this.state.GuardianSign.Name,
      'NotetypeId': 2,
      'ProgressNotes_CAS': {
        'Id': this.state.get_soap && this.state.get_soap.progressNotes_CAS ? this.state.get_soap.progressNotes_CAS.id : 0,
       
        'Notes': formProps.notes,
        'ProgressNote_ParentReport_CAS': {
          'ParentReportId': this.state.get_soap && this.state.get_soap.progressNotes_CAS && this.state.get_soap.progressNotes_CAS.progressNote_ParentReport_CAS ? this.state.get_soap.progressNotes_CAS.progressNote_ParentReport_CAS.id : 0,
          'ProgressNoteId': this.state.get_soap && this.state.get_soap.progressNotes_CAS ? this.state.get_soap.progressNotes_CAS.id : 0,
          'Happy': formProps.Happy || 0,
          'Tired': formProps.Tired || 0,
          'Sick': formProps.Sick || 0,
          'Wellrested': formProps.Wellrested || 0,
          'Sensorysicking': formProps.Sensorysicking || 0,
          'Upset': formProps.Upset || 0,
          'OtherPN': formProps.OtherPN || 0,
          'OtherPNNotes': formProps.OtherPN ? formProps.OtherPNNotes : '',
          'IsWarrantTherapy': formProps.IsWarrantTherapy || 0,
        },
        'ProgressNote_SymptomsObserved_CAS': {
          'SymptomsObservedId': this.state.get_soap && this.state.get_soap.progressNotes_CAS && this.state.get_soap.progressNotes_CAS.ProgressNote_SymptomsObserved_CAS ? this.state.get_soap.progressNotes_CAS.ProgressNote_SymptomsObserved_CAS.id : 0,
          'ProgressNoteId': this.state.get_soap && this.state.get_soap.progressNotes_CAS ? this.state.get_soap.progressNotes_CAS.id : 0,
          'SkillDeftReceptiveLanguage': formProps.SkillDeftReceptiveLanguage || 0,
          'SkillDeftAdaptiveBehavior': formProps.SkillDeftAdaptiveBehavior || 0,
          'SkillDeftExpressiveLanguage': formProps.SkillDeftExpressiveLanguage || 0,
          'SkillDeftImitationSkills': formProps.SkillDeftImitationSkills || 0,
          'SkillDeftSocialSkills': formProps.SkillDeftSocialSkills || 0,
          'SkillDeftCommunitySafetySkills': formProps.SkillDeftCommunitySafetySkills || 0,
          'SkillDeftPlaySkills': formProps.SkillDeftPlaySkills || 0,
          'SkillDeftOther': formProps.SkillDeftOther || 0,
          'SkillDeftOtherNotes': formProps.SkillDeftOther ? formProps.SkillDeftOtherNotes : '',

          'TechBehSampling': formProps.TechBehSampling || 0,
          'TechBehBehavioralSkillsTraining': formProps.TechBehBehavioralSkillsTraining || 0,
          'TechBehDTT': formProps.TechBehDTT || 0,
          'TechBehShaping': formProps.TechBehShaping || 0,
          'TechBehErrorlessTeaching': formProps.TechBehErrorlessTeaching || 0,
          'TechBehSystematicPromptFading': formProps.TechBehSystematicPromptFading || 0,
          'TechBehNET': formProps.TechBehNET || 0,         
          'TechBehOther': formProps.TechBehOther || 0,
          'TechBehOtherNotes': formProps.TechBehOther ? formProps.TechBehOtherNotes : '',
          
        },
        'ProgressNote_TreatmentGoals_CAS': {
          'TreatmentGoalId': this.state.get_soap && this.state.get_soap.progressNotes_CAS && this.state.get_soap.progressNotes_CAS.ProgressNote_TreatmentGoals_CAS ? this.state.get_soap.progressNotes_CAS.ProgressNote_TreatmentGoals_CAS.id : 0,
          'ProgressNoteId': this.state.get_soap && this.state.get_soap.progressNotes_CAS ? this.state.get_soap.progressNotes_CAS.id : 0,
          
          'SessionComments1': formProps.SessionComments1 || '',
          'SessionMastery1': formProps.SessionMastery1 || 0,
          'ContinueTeaching1': formProps.ContinueTeaching1 || 0,
          'Generalized1': formProps.Generalized1 || 0,
          'Hold1': formProps.Hold1 || 0,
          'DevelopProtocol1': formProps.DevelopProtocol1 || 0,         
          'OtherTG1': formProps.OtherTG1 || 0,
          'OtherTGNotes1': formProps.OtherTG1 ? formProps.OtherTGNotes1 : '',

          'SessionComments2': formProps.SessionComments2 || '',
          'SessionMastery2': formProps.SessionMastery2 || 0,
          'ContinueTeaching2': formProps.ContinueTeaching2 || 0,
          'Generalized2': formProps.Generalized2 || 0,
          'Hold2': formProps.Hold2 || 0,
          'DevelopProtocol2': formProps.DevelopProtocol2 || 0,         
          'OtherTG2': formProps.OtherTG2 || 0,
          'OtherTGNotes2': formProps.OtherTG2 ? formProps.OtherTGNotes2 : '',

          'SessionComments3': formProps.SessionComments3 || '',
          'SessionMastery3': formProps.SessionMastery3 || 0,
          'ContinueTeaching3': formProps.ContinueTeaching3 || 0,
          'Generalized3': formProps.Generalized3 || 0,
          'Hold3': formProps.Hold3 || 0,
          'DevelopProtocol3': formProps.DevelopProtocol3 || 0,         
          'OtherTG3': formProps.OtherTG3 || 0,
          'OtherTGNotes3': formProps.OtherTG3 ? formProps.OtherTGNotes3 : '',
        },
        'ProgressNote_Generalization_CAS': {
          'GeneralizationId': this.state.get_soap && this.state.get_soap.progressNotes_CAS && this.state.get_soap.progressNotes_CAS.ProgressNote_Generalization_CAS ? this.state.get_soap.progressNotes_CAS.ProgressNote_Generalization_CAS.id : 0,
          'ProgressNoteId': this.state.get_soap && this.state.get_soap.progressNotes_CAS ? this.state.get_soap.progressNotes_CAS.id : 0,
          
          'GenReceptiveLanguage': formProps.GenReceptiveLanguage || 0,
          'GenPlay': formProps.GenPlay || 0,
          'GenExpressiveLanguage': formProps.GenExpressiveLanguage || 0,
          'GenFCT': formProps.GenFCT || 0,
          'GenImitation': formProps.GenImitation || 0,
          'GenAdaptiveBehavior': formProps.GenAdaptiveBehavior || 0,         
          'GenOther': formProps.GenOther || 0,
          'GenOtherNotes': formProps.GenOther ? formProps.GenOtherNotes : '',

          'ProgressAllTargets': formProps.ProgressAllTargets || 0,
          'ProgressMostTargets': formProps.ProgressMostTargets || 0,
          'ProgressMultipleTargets': formProps.ProgressMultipleTargets || 0,         
          'ProgressOtherTargets': formProps.ProgressOtherTargets || 0,
          'ProgressOtherTargetsNotes': formProps.ProgressOtherTargets ? formProps.ProgressOtherTargetsNotes : '',

          'TotalNumberOfTrials': formProps.TotalNumberOfTrials || '',
        },
        'ProgressNote_BehaviorReduction_CAS': {
          'BehaviorReductionId': this.state.get_soap && this.state.get_soap.progressNotes_CAS && this.state.get_soap.progressNotes_CAS.ProgressNote_BehaviorReduction_CAS ? this.state.get_soap.progressNotes_CAS.ProgressNote_BehaviorReduction_CAS.id : 0,
          'ProgressNoteId': this.state.get_soap && this.state.get_soap.progressNotes_CAS ? this.state.get_soap.progressNotes_CAS.id : 0,
          'DifferentialReinforcement': formProps.DifferentialReinforcement || 0,
          'Extinction': formProps.Extinction || 0,
          'BehavioralMomentum': formProps.BehavioralMomentum || 0,
          'FCT': formProps.FCT || 0,
          'Assessment': formProps.Assessment || 0,
          'OperantReinforcement': formProps.OperantReinforcement || 0,
          'AntecedentManipulations': formProps.AntecedentManipulations || 0,
          'TaskAnalysis': formProps.TaskAnalysis || 0,
          'PositiveReinforcement': formProps.PositiveReinforcement || 0,
          'Punishment': formProps.Punishment || 0,
          'OtherBR': formProps.OtherBR || 0,
          'OtherBRNotes': formProps.OtherBR ? formProps.OtherBRNotes : '',          
        },
        'ProgressNote_ProtocolModification_CAS': {
          'ProtocolModificationId': this.state.get_soap && this.state.get_soap.progressNotes_CAS && this.state.get_soap.progressNotes_CAS.ProgressNote_ProtocolModification_CAS ? this.state.get_soap.progressNotes_CAS.ProgressNote_ProtocolModification_CAS.id : 0,
          'ProgressNoteId': this.state.get_soap && this.state.get_soap.progressNotes_CAS ? this.state.get_soap.progressNotes_CAS.id : 0,
          'DataAnalysis': formProps.DataAnalysis || 0,
          'UpdatedBIP': formProps.UpdatedBIP || 0,
          'AssessmentPM': formProps.AssessmentPM || 0,
          'ModificationsToCurrentProgramming': formProps.ModificationsToCurrentProgramming || 0,
          'DevelopNewProgramming': formProps.DevelopNewProgramming || 0,          
          'OtherPM': formProps.OtherPM || 0,
          'OtherPMNotes': formProps.OtherPM ? formProps.OtherPMNotes : '',          
        },
        'ProgressNote_BTGuidance_CAS': {
          'BTGuidanceId': this.state.get_soap && this.state.get_soap.progressNotes_CAS && this.state.get_soap.progressNotes_CAS.ProgressNote_BTGuidance_CAS ? this.state.get_soap.progressNotes_CAS.ProgressNote_BTGuidance_CAS.id : 0,
          'ProgressNoteId': this.state.get_soap && this.state.get_soap.progressNotes_CAS ? this.state.get_soap.progressNotes_CAS.id : 0,
          
          'AccuracyOfDataCollection': formProps.AccuracyOfDataCollection || 0,
          'EffectivelyImplementsDTT': formProps.EffectivelyImplementsDTT || 0,
          'EffectivelyImplementsClientBIP': formProps.EffectivelyImplementsClientBIP || 0,
          'EffectivelyImplementsErrorCorrection': formProps.EffectivelyImplementsErrorCorrection || 0,
          'EffectivelyImplementsSystematicPromptFading': formProps.EffectivelyImplementsSystematicPromptFading || 0,    
          'EffectivelyEstablishesInstructionalControl': formProps.EffectivelyEstablishesInstructionalControl || 0,
          'ImplementsReinforcementProceduresEffectively': formProps.ImplementsReinforcementProceduresEffectively || 0,          
          'OtherBT': formProps.OtherBT || 0,
          'OtherBTNotes': formProps.OtherBT ? formProps.OtherBTNotes : '',          
        }        
      },
      'PatientEncounterServiceCodes': CPTcodes,
      'PatientEncounterDiagnosisCodes': ICDArray,
      'isBillableEncounter': this.state.appointmentTypeIsBillable ? true : false,
    };
    // console.log('submit data =========',formData);
    let parentReportCheckPermission = false;
    let symptomsObservedPermission = false;
    let treatmentGoalsPermission = false;
    let generalizationPermission = false;
    let behaviorReductionPermission = false;
    let protocolModificationPermission = false;
    let btGuidanceCheckPermission = false;
    

    // Check directly formData
    if(formData.ProgressNotes_CAS) {
        let parentReportCheck = formData.ProgressNotes_CAS.ProgressNote_ParentReport_CAS;
        let symptomsObservedCheck = formData.ProgressNotes_CAS.ProgressNote_SymptomsObserved_CAS;
        let treatmentGoalsCheck = formData.ProgressNotes_CAS.ProgressNote_TreatmentGoals_CAS;
        let GeneralizationCheck = formData.ProgressNotes_CAS.ProgressNote_Generalization_CAS;
        let BehaviorReductionCheck = formData.ProgressNotes_CAS.ProgressNote_BehaviorReduction_CAS;
        let ProtocolModificationCheck = formData.ProgressNotes_CAS.ProgressNote_ProtocolModification_CAS;
        let BTGuidanceCheck = formData.ProgressNotes_CAS.ProgressNote_BTGuidance_CAS;
        
        // For Parent Report
        if(parentReportCheck.Happy === 0 && parentReportCheck.Tired === 0 && parentReportCheck.Sick === 0 && parentReportCheck.Wellrested === 0 && parentReportCheck.Sensorysicking === 0 && parentReportCheck.Upset === 0 && parentReportCheck.OtherPN === 0) {
          parentReportCheckPermission = false;
          this.setState({ isParentReportCheckAllowed: false });
        } else {
          parentReportCheckPermission = true;
          this.setState({ isParentReportCheckAllowed: true });
        }

        // For Symptoms Observed
        if(symptomsObservedCheck.SkillDeftReceptiveLanguage === 0 && symptomsObservedCheck.SkillDeftAdaptiveBehavior === 0 && symptomsObservedCheck.SkillDeftExpressiveLanguage === 0 && symptomsObservedCheck.SkillDeftImitationSkills === 0 
            && symptomsObservedCheck.SkillDeftSocialSkills === 0 && symptomsObservedCheck.SkillDeftCommunitySafetySkills === 0 && symptomsObservedCheck.SkillDeftPlaySkills === 0 && symptomsObservedCheck.SkillDeftOther === 0) {
          symptomsObservedPermission = false;
          this.setState({ isSymptomsObservedAllowed : false })
        } else {
          symptomsObservedPermission = true;
          this.setState({ isSymptomsObservedAllowed: true })
        }

        if(symptomsObservedCheck.TechBehSampling === 0 && symptomsObservedCheck.TechBehBehavioralSkillsTraining === 0 && symptomsObservedCheck.TechBehDTT === 0 && symptomsObservedCheck.TechBehShaping === 0 
          && symptomsObservedCheck.TechBehErrorlessTeaching === 0 && symptomsObservedCheck.TechBehSystematicPromptFading === 0 && symptomsObservedCheck.TechBehNET === 0 && symptomsObservedCheck.TechBehOther === 0 ) {
        symptomsObservedPermission = false;
          this.setState({ isSymptomsObservedAllowed : false })
        } else {
          symptomsObservedPermission = true;
          this.setState({ isSymptomsObservedAllowed: true })
        }

        // For Treatment Goals
        if(treatmentGoalsCheck.SessionMastery1 === 0 && treatmentGoalsCheck.ContinueTeaching1 === 0 && treatmentGoalsCheck.Generalized1 === 0 && treatmentGoalsCheck.Hold1 === 0 && treatmentGoalsCheck.DevelopProtocol1 === 0 && treatmentGoalsCheck.OtherTG1 === 0) {
          treatmentGoalsPermission = false;
          this.setState({ isTreatmentGoalsAllowed : false })
        } else {
          treatmentGoalsPermission = true;
          this.setState({ isTreatmentGoalsAllowed : true })
        }

        if(treatmentGoalsCheck.SessionMastery2 === 0 && treatmentGoalsCheck.ContinueTeaching2 === 0 && treatmentGoalsCheck.Generalized2 === 0 && treatmentGoalsCheck.Hold2 === 0 && treatmentGoalsCheck.DevelopProtocol2 === 0 && treatmentGoalsCheck.OtherTG2 === 0) {
          treatmentGoalsPermission = false;
          this.setState({ isTreatmentGoalsAllowed : false })
        } else {
          treatmentGoalsPermission = true;
          this.setState({ isTreatmentGoalsAllowed : true })
        }

        if(treatmentGoalsCheck.SessionMastery3 === 0 && treatmentGoalsCheck.ContinueTeaching3 === 0 && treatmentGoalsCheck.Generalized3 === 0 && treatmentGoalsCheck.Hold3 === 0 && treatmentGoalsCheck.DevelopProtocol3 === 0 && treatmentGoalsCheck.OtherTG3 === 0) {
          treatmentGoalsPermission = false;
          this.setState({ isTreatmentGoalsAllowed : false })
        } else {
          treatmentGoalsPermission = true;
          this.setState({ isTreatmentGoalsAllowed : true })
        }

        // For Generalization
        if(GeneralizationCheck.GenReceptiveLanguage === 0 && GeneralizationCheck.GenPlay === 0 && GeneralizationCheck.GenExpressiveLanguage === 0 && GeneralizationCheck.GenFCT === 0 && GeneralizationCheck.GenImitation === 0 && GeneralizationCheck.GenAdaptiveBehavior === 0 && GeneralizationCheck.GenOther === 0) {
          generalizationPermission = false;
          this.setState({ isGeneralizationAllowed: false });
        } else {
          generalizationPermission = true;
          this.setState({ isGeneralizationAllowed: true });
        }

        if(GeneralizationCheck.ProgressAllTargets === 0 && GeneralizationCheck.ProgressMostTargets === 0 && GeneralizationCheck.ProgressMultipleTargets === 0 && GeneralizationCheck.ProgressOtherTargets === 0) {
          generalizationPermission = false;
          this.setState({ isGeneralizationAllowed: false });
        } else {
          generalizationPermission = true;
          this.setState({ isGeneralizationAllowed: true });
        }

        // For BehaviorReduction
        if(BehaviorReductionCheck.DifferentialReinforcement === 0 && BehaviorReductionCheck.Extinction === 0 && BehaviorReductionCheck.BehavioralMomentum === 0 && BehaviorReductionCheck.FCT === 0 && BehaviorReductionCheck.Assessment === 0 && BehaviorReductionCheck.OperantReinforcement === 0 && BehaviorReductionCheck.AntecedentManipulations === 0
          && BehaviorReductionCheck.TaskAnalysis === 0 && BehaviorReductionCheck.PositiveReinforcement === 0 && BehaviorReductionCheck.Punishment === 0 && BehaviorReductionCheck.OtherBR === 0) {
            behaviorReductionPermission = false;
          this.setState({ isBehaviorReductionAllowed: false });
        } else {
          behaviorReductionPermission = true;
          this.setState({ isBehaviorReductionAllowed: true });
        }

        // For ProtocolModification
        if(this.props.hasBCBARole && ProtocolModificationCheck.DataAnalysis === 0 && ProtocolModificationCheck.UpdatedBIP === 0 && ProtocolModificationCheck.AssessmentPM === 0 && ProtocolModificationCheck.ModificationsToCurrentProgramming === 0 && ProtocolModificationCheck.DevelopNewProgramming === 0 && ProtocolModificationCheck.OtherPM === 0) {
            protocolModificationPermission = false;
          this.setState({ isProtocolModificationAllowed: false });
        } else {
          protocolModificationPermission = true;
          this.setState({ isProtocolModificationAllowed: true });
        }

        // For BTGuidance
        if(this.props.hasBCBARole && BTGuidanceCheck.AccuracyOfDataCollection === 0 && BTGuidanceCheck.EffectivelyImplementsDTT === 0 && BTGuidanceCheck.EffectivelyImplementsClientBIP === 0 && BTGuidanceCheck.EffectivelyImplementsErrorCorrection === 0 && BTGuidanceCheck.EffectivelyImplementsSystematicPromptFading === 0 
          && BTGuidanceCheck.EffectivelyEstablishesInstructionalControl === 0 && BTGuidanceCheck.ImplementsReinforcementProceduresEffectively === 0 && BTGuidanceCheck.OtherBT === 0) {
          btGuidanceCheckPermission = false;
          this.setState({ isBTGuidanceAllowed: false });
        } else {
          btGuidanceCheckPermission = true;
          this.setState({ isBTGuidanceAllowed: true });
        }
    }

    // check for user is Admin and Soap has been rendered ...
    let isAdminUpdateAfterRendered = this.state.isAdminUpdateAfterRendered && this.props.modifyAfterRenderPermission;
    if(parentReportCheckPermission === true && symptomsObservedPermission === true && treatmentGoalsPermission === true && generalizationPermission === true && behaviorReductionPermission === true && protocolModificationPermission === true && btGuidanceCheckPermission === true) {
      this.props.savePatientSoapAction(formData, isGenerateClaim, isAdminUpdateAfterRendered);
    } else {
      Alert.error('Please fill therapy session notes details!', {
        position: 'bottom-right',
        effect: 'slide',
      });
    }
  }

  changeIsWarrantTherapy = (e, value) => {    
    this.setState({ IsWarrantTherapy: parseInt(value || 0, 10)});
  };

  handleOpen = () => {
    this.setState({ open: true, soapPage: true });
  };
  handleClose = () => {
    this.setState({ open: false });
  };
  handleOpenCPT = () => {
    this.setState({ openCPT: true, soapPage: true });
  };
  handleCloseCPT = () => {
    this.setState({ openCPT: false });
  };
  handleOpenSign = () => {
    this.props.getGeoLocation();
    this.setState({ openSign: true, soapPage: true });
  };
  handleCloseSign = () => {
    this.setState({ openSign: false });
  };
  DiagnosisAlertClick = (e, index) => {
    Alert.closeAll();
    if (index > -1) {
      let arr = this.state.diagnosisArray.filter((Obj) => !Obj.IsDeleted);
      if (arr[index].Id > 0) {
        arr[index].IsDeleted = true;
      } else {
        arr.splice(index, 1);
      }
      this.setState({ diagnosisArray: arr });
    }
  }
  handleRemoveDiagnosisClick = (e, index) => {
    Alert.warning('Are you sure you want to remove this diagnosis?', {
      position: 'bottom-right',
      effect: 'slide',
      timeout: 10000,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.DiagnosisAlertClick,
        id: index,
      },
    });
  }
  CPTCodeAlertClick = (e, data) => {
    if (data.AuthProcedureCPTLinkId) {
      // let postData = {
      //   authProcedureCPTLinkId: data.AuthProcedureCPTLinkId,
      //   actionName: 'Delete',
      // };
      // this.props.updateServiceCodeBlockedUnits(postData);
    }
    let index = data.index;
    Alert.closeAll();
    if (index > -1) {
      let arr = this.state.CPTTableData.filter((Obj) => !Obj.IsDeleted);
      if (arr[index].Id > 0) {
        arr[index].IsDeleted = true;
      } else {
        arr.splice(index, 1);
      }
      this.setState({ CPTTableData: arr });
    }
  }
  handleRemoveCPTCodeClick = (e, data) => {
    Alert.warning('Are you sure you want to remove this service code?', {
      position: 'bottom-right',
      effect: 'slide',
      timeout: 10000,
      customFields: {
        displayComponent: true,
        handleButtonClick: this.CPTCodeAlertClick,
        id: data,
      },
    });
  }
  renderDiagnosis() {
    if (this.state.diagnosisArray.filter((Obj) => !Obj.IsDeleted).length === 0) {
      return (
        <TableRow><TableRowColumn className="text-center no-record">No record found.</TableRowColumn></TableRow>
      );
    }

    return this.state.diagnosisArray.filter((Obj) => !Obj.IsDeleted).map((diagnosis, index) => {
      return (
        <TableRow key={index}>
          <TableRowColumn width="30%">{diagnosis.ICDCode}</TableRowColumn>
          <TableRowColumn width="70%">{diagnosis.Description ? diagnosis.Description : '-'}</TableRowColumn>
          {/* {this.props.deletePermission && !this.state.isSoapCompleted ?
            <TableRowColumn><button onClick={(e) => this.handleRemoveDiagnosisClick(e, index)} title="Remove" type="button" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button></TableRowColumn>
            : null} */}
        </TableRow>
      );
    });
  }
  renderCpt() {
    if (this.state.CPTTableData.filter((Obj) => !Obj.IsDeleted).length === 0) {
      return (
        <TableRow><TableRowColumn className="text-center no-record">No record found.</TableRowColumn></TableRow>
      );
    }

    return this.state.CPTTableData.filter((Obj) => !Obj.IsDeleted).map((cpt, index) => {
      // let data = {
      //   index: index,
      //   AuthProcedureCPTLinkId: cpt.AuthProcedureCPTLinkId,
      // };
      return (
        <TableRow key={index}>
          <TableRowColumn>{cpt.ServiceCode ? cpt.ServiceCode : '-'}</TableRowColumn>
          <TableRowColumn>{cpt.AttachedModifiers ? cpt.AttachedModifiers : '-'}</TableRowColumn>
          <TableRowColumn>{cpt.Description ? cpt.Description : '-'}</TableRowColumn>
          {/* {this.props.deletePermission && !this.state.isSoapCompleted ?
            <td width="10%"><button onClick={(e) => this.handleRemoveCPTCodeClick(e, data)} title="Remove" type="button" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button></td>
            : null} */}
        </TableRow>
      );
    });
  }

  handleAddDiagnosis = (formValues) => {
    let diseaseDetails = extractDataFromArray(this.state.master_data.masterICD, formValues.ICDID);
    let arr = this.state.diagnosisArray;
    if (arr.indexOf(formValues) === -1) {
      arr.push({
        'DiagnosisDate': moment(formValues.DiagnosisDate).format(),
        'Description': diseaseDetails.description,
        'ICDCodeId': diseaseDetails.id,
        'ICDCode': diseaseDetails.code,
        'IsDeleted': false,
        'Id': 0,
      });
      this.setState({ diagnosisArray: arr });
    }
  }
  handleAddCPT = (formValues) => {
    if (formValues.AuthProcedureCPTLinkId) {
      // let postData = {
      //   authProcedureCPTLinkId: formValues.AuthProcedureCPTLinkId,
      //   actionName: 'Add',
      // };
      // this.props.updateServiceCodeBlockedUnits(postData);
    }
    let cptObj = extractDataFromArray(this.state.master_data.masterServiceCode, formValues.CPTID);
    let arr = this.state.CPTTableData;
    if (arr.indexOf(cptObj) === -1) {
      arr.push({
        'AuthProcedureCPTLinkId': formValues.AuthProcedureCPTLinkId,
        'AuthorizationNumber': formValues.AuthorizationNumber,
        'ServiceCodeId': cptObj.id,
        'ServiceCode': cptObj.serviceCode,
        'Description': cptObj.description,
        'IsDeleted': false,
        'Id': 0,
        'Modifier1': formValues.Modifier1 ? formValues.Modifier1 : null,
        'Modifier2': formValues.Modifier2 ? formValues.Modifier2 : null,
        'Modifier3': formValues.Modifier3 ? formValues.Modifier3 : null,
        'Modifier4': formValues.Modifier4 ? formValues.Modifier4 : null,
      });
      this.setState({ CPTTableData: arr });
    }
  }
  handleAddSign = (formProps) => {

    let signBytes = formProps.signBytes.substring(22);
    let data = {
      Bytes: signBytes,
      Date: moment().format('YYYY-MM-DDTHH:mm:ss'),
      Name: '',
      Latitude: 0.0,
      Longitude: 0.0,
    };
    switch (formProps.Signee) {
      case 1:
        data.id = this.state.EmployeeSign.id || null;
        data.Name = extractNameFromArray(this.state.signatureStaffs, formProps.StaffID);
        data.Latitude = this.props.latitude;
        data.Longitude = this.props.longitude;
        this.setState({ EmployeeSign: data });
        this.filter.isEmployeeSigned = true;
        this.saveEncounterSigns(data.id, data, null, null);
        break;
      case 2:
        data.id = this.state.ClientSign.id || null;
        data.Name = this.state.patientName;
        data.Latitude = this.props.latitude;
        data.Longitude = this.props.longitude;
        this.setState({ ClientSign: data });
        this.filter.isClientSigned = true;
        this.saveEncounterSigns(data.id, null, data, null);
        break;
      case 3:
        data.id = this.state.GuardianSign.id || null;
        data.Name = formProps.Guardian;
        data.Latitude = this.props.latitude;
        data.Longitude = this.props.longitude;
        this.setState({ GuardianSign: data });
        this.filter.isGuardianSigned = true;
        this.saveEncounterSigns(data.id, null, null, data);
        break;
      case 4:
          data.id = this.state.RenderingProviderSign.id || null;
          //data.Name = extractNameFromArray(this.state.signatureRenderingProviders, formProps.RenderingProviderID);
          data.Name = formProps.SupervisingClinician;
          data.Latitude = this.props.latitude;
          data.Longitude = this.props.longitude;
          this.setState({ RenderingProviderSign: data });
          this.filter.isRenderingProviderSigned = true;
          this.saveEncounterSigns(data.id, null, null, null, data);
          break;
      default:
        break;
    }

    this.setState({ isAllSigned: this.checkIsAllRequiredSigned() });
  }

  checkIsAllRequiredSigned() {
    let employee_Signed = true, client_signed = true, guardian_signed = true, rederingProvider_signed = true;
    if (this.state.signRequired.employee_sign) {
      if (this.filter.isEmployeeSigned) {
        employee_Signed = true;
      } else {
        employee_Signed = false;
      }
    }
    if (this.state.signRequired.client_sign) {
      if (this.filter.isClientSigned) {
        client_signed = true;
      } else {
        client_signed = false;
      }
    }
    if (this.state.signRequired.guardian_sign) {
      if (this.filter.isGuardianSigned) {
        guardian_signed = true;
      } else {
        guardian_signed = false;
      }
    }

    if (this.state.signRequired.rederingProvider_sign) {
      if (this.filter.isRenderingProviderSigned) {
        rederingProvider_signed = true;
      } else {
        rederingProvider_signed = false;
      }
    }

    // finally check if all required are signed ...
    if (employee_Signed && client_signed && guardian_signed && rederingProvider_signed) {
      return true;
    } else {
      return false;
    }
  }

  saveEncounterSigns(id = 0, employeeSign, patientSign, guradianSign, renderingProviderSign) {
    let postData = {
      id: id,
      patientEncounterId: this.state.encounterId,
      patientId: patientSign ? this.state.patient_id : null,
      patientSign: patientSign ? patientSign.Bytes : null,
      patientSignDate: patientSign ? moment.utc().format('YYYY-MM-DDTHH:mm:ss') : null,
      staffId: employeeSign ? this.state.staffID : null,
      clinicianSign: employeeSign ? employeeSign.Bytes : null,
      clinicianSignDate: employeeSign ? moment.utc().format('YYYY-MM-DDTHH:mm:ss') : null,
      guardianName: guradianSign ? guradianSign.Name : null,
      guardianSign: guradianSign ? guradianSign.Bytes : null,
      guardianSignDate: guradianSign ? moment.utc().format('YYYY-MM-DDTHH:mm:ss') : null,
      //staffId: renderingProviderSign ? this.state.renderingProviderID : null,
      renderingProviderName: renderingProviderSign ? renderingProviderSign.Name : null,
      renderingProviderSign: renderingProviderSign ? renderingProviderSign.Bytes : null,
      renderingProviderSignDate: renderingProviderSign ? moment.utc().format('YYYY-MM-DDTHH:mm:ss') : null,
      latitude: this.props.latitude ? this.props.latitude : 0.0,
      longitude: this.props.longitude ? this.props.longitude : 0.0,
    };
    // console.log(JSON.stringify(postData));
    this.props.saveEncounterSigns(postData);
  }

  // componentDidUpdate() {
  //   if(this.state.isGenerateClaimAfterRendered)
  //   {     
  //     var link = document.getElementById('btnComplete');      
  //     if(link)      
  //       link.click();            
  //   }    
  // }
  
  render() {
    const { handleSubmit } = this.props;
    // const tableClass = classNames({
    //   'table': true,
    //   'table-striped': this.props.bordered,
    //   'table-bordered': this.props.bordered,
    //   'table-hover': true,
    //   'table-condensed': this.props.condensed,
    //   'customtable': true,
    // });
    const tableClass1 = classNames({
      'table': true,
      'customtable': true,
      'fixedheader': true,
      'table-hover': true,
    });
    let totalUnitsConsumed = (this.state.get_soap && this.state.get_soap.unitsConsumed) || 0;
    let canOnlyAddSignForTheirNotes = true;
    if (this.props.canOnlyAddSignForTheirNotes && !(this.state.isAdminUpdateAfterRendered && this.props.modifyAfterRenderPermission)) {
      canOnlyAddSignForTheirNotes = this.props.currentLoginUserId === this.state.staffID;
    }
    return (
      <div>
        <h2 className="page_title">Visit Details</h2>
        {this.state.patient_id ?
          <PatientInfo patientId={this.state.patient_id} />
          : ''}
        {this.state.open ?
          <ProblemModal soapPage={this.state.soapPage} diagnosisArray={this.state.diagnosisArray} master_data={this.state.master_data} closeDialog={this.handleClose} handleAddDiagnosis={this.handleAddDiagnosis} />
          : null}
        {this.state.openCPT ?
          <CPTModal soapPage={this.state.soapPage} patientId={this.state.patient_id} dateOfService={this.state.DateOfService} cptArray={this.state.CPTTableData} master_CPT={this.state.master_data.masterServiceCode ? this.state.master_data.masterServiceCode : this.props.master_data.masterServiceCode} closeDialog={this.handleCloseCPT} handleAddCPT={this.handleAddCPT} />
          : null}
        {this.state.openSign ?
          this.props.agencyName.toUpperCase() === CBG ?
          <SignatureWithRenderingProviderModal staffID={this.state.staffID} renderingProviderID={this.state.renderingProviderID} clientName={this.state.patientName} staffs={this.state.signatureStaffs} renderingProviders={this.state.signatureRenderingProviders} closeDialog={this.handleCloseSign} handleAddSign={this.handleAddSign.bind(this)} />
          :
          <SignatureModal staffID={this.state.staffID} clientName={this.state.patientName} staffs={this.state.signatureStaffs} closeDialog={this.handleCloseSign} handleAddSign={this.handleAddSign.bind(this)} />
          : null}
        <div className="clearfix"></div>
        <div className="readmin-panel mt-15">
          <div className="panel-body">
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmit.bind(this))}>             
                <div className="row">
                    <div className="col-9 col-sm-9 col-md-9">
                      {this.state.isGenerateClaimAfterRendered ?
                        <div className={'alert alert-danger-soap update-pwd'}>
                            <strong>**YOU MUST SCROLL DOWN AND CLICK ON THE COMPLETE BUTTON TO SAVE YOUR CHANGES. <br/> CHANGES MAY NOT BE SAVED UNLESS YOU CLICK COMPLETE! <br/> IF THERE IS NO COMPLETE BUTTON THEN YOUR CHANGES HAVE BEEN SAVED AUTOMATICALLY. **</strong>
                        </div>
                        : 
                        <CommonButton className="mb-20" label="Go back to scheduler" primary={true} onTouchTap={this.handleCancel} />
                      } 
                    </div>
                    <div className="col-3 col-sm-3 col-md-3 btn_rt">                    
                      { this.props.agencyName.toUpperCase() === CBG ?                                  
                        <CommonButton className="mb-20" label="Clock In" disabled={this.state.clockInDateTime ? true : false} primary={true} onTouchTap={this.handleClockIn} />                
                      : null}
                    </div>
                </div>
                <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title no_margin mb-20">
                    <h3>Appointment</h3>
                    <i className="flaticon flaticon-medical-4"></i>
                  </div>
                </div>
                <div className="col-sm-12 ml-20">
                  <div className="col-sm-12 soap_content">
                    <div className="soap_detail detail_wd">
                      <p>
                        <b>Appointment :</b> <span>{this.state.appointmentTypeName ? this.state.appointmentTypeName : '-'}</span>
                      </p>
                      <p>
                        <b>Appointment Date :</b> <span>{this.state.appointmentDate ? this.state.appointmentDate : '-'}</span>
                      </p>
                      <p>
                        <b>Appointment Time:</b> <span>{this.state.appointmentTime ? this.state.appointmentTime : '-'}</span>
                      </p>
                      <p>
                        <b>Seen By :</b> <span>{this.state.staffName ? this.state.staffName : '-'}</span>
                      </p>
                      {/* <p>
                        <b>Location Type :</b> <span>{this.state.serviceFacility || '-'}</span>
                      </p> */}
                      <p>
                        <b>Service Type :</b> <span>{this.state.isDirectService ? 'Direct' : 'Indirect'}</span>
                      </p>
                      <p>
                        <b>Service Location :</b> <span>{this.state.PatientLocationName ? this.state.PatientLocationName : '-'}</span>
                      </p>
                      <p>
                        <b>Unit Billed :</b> <span>{totalUnitsConsumed}</span>
                      </p>
                      <p>
                        <b>Payer Name :</b> <span>{this.state.payerName ? this.state.payerName : '-'}</span>
                      </p>
                      <p>
                        <b>Client Name :</b> <span>{this.state.patientName ? this.state.patientName : '-'}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="clearfix"></div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>Service</h3>
                    <i className="flaticon flaticon-time-1"></i>
                  </div>
                </div>
                <div className="col-sm-6">
                  <Field
                    name="serviceStartTime"
                    placeholder="Start Time"
                    fullWidth={true}
                    // disabled={this.state.isSoapCompleted}
                    disabled={true}
                    component={renderTimePicker}
                    selected={this.state.serviceStartTime}
                    onDateChange={this.onDateChange}

                  />
                </div>
                <div className="col-sm-6">
                  <Field
                    name="serviceEndTime"
                    placeholder="End Time"
                    // disabled={this.state.isSoapCompleted}
                    disabled={true}
                    component={renderTimePicker}
                    selected={this.state.serviceEndTime}
                    onDateChange={this.onDateChange}
                    fullWidth={true}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h3>Progress Notes</h3>
                    <i className="flaticon flaticon-interface-2"></i>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Parent report/ observation upon arrival</h5><span style={{ color: 'red'}}>*</span>
                    {!this.state.isParentReportCheckAllowed && <div style={{ color: 'red', marginLeft: '20px'}}>(Please select at least one)</div>}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className='col-sm-3 mt-35'>
                  <Field
                    name="Happy"
                    label="Happy"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-3 mt-35'>
                  <Field
                    name="Tired"
                    label="Tired"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-3 mt-35'>
                  <Field
                    name="Sick"
                    label="Sick"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-3 mt-35'>
                  <Field
                    name="Wellrested"
                    label="Well rested"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-3 mt-35'>
                  <Field
                    name="Sensorysicking"
                    label="Sensory seeking"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-3 mt-35'>
                  <Field
                    name="Upset"
                    label="Upset"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-3 mt-35'>
                  <Field
                    name="OtherPN"
                    label="Other"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOtherPN &&
                  (<div className='col-sm-3 require'>
                  <Field
                    name="OtherPNNotes"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={this.state.isSoapCompleted}
                    component={renderTextField}
                  />
                </div>)}
              </div>
              <div className="row">
                <div className='col-sm-12 mt-35'>
                  <div className="panel_title no_margin mb-20 require">
                    <h5>In a state that warrants therapy?</h5>
                  </div>
                  <Field name="IsWarrantTherapy"
                    options={[{ id: 1, value: 'Yes' }, { id: 0, value: 'No' }]}
                    selectedValue={this.state.IsWarrantTherapy}
                    onChange={this.changeIsWarrantTherapy}
                    disabled={this.state.isSoapCompleted}
                    component={renderCustomRadioButtons} />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Symptoms observed during session</h5><span style={{ color: 'red' }}>*</span>
                    {!this.state.isSymptomsObservedAllowed && <div style={{ color: 'red', marginLeft: '20px'}}>(Please select at least one)</div>}
                  </div>
                </div>
              </div>
              <div className="row mt-35">               
                <div className="col-sm-12"><h6><strong>Skill Deficits</strong></h6></div>               
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SkillDeftReceptiveLanguage"
                    label="Deficits in receptive language"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SkillDeftAdaptiveBehavior"
                    label="Deficits in adaptive behavior"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SkillDeftExpressiveLanguage"
                    label="Deficits in expressive language"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SkillDeftImitationSkills"
                    label="Deficits in imitation skills"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SkillDeftSocialSkills"
                    label="Deficits in social skills"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SkillDeftCommunitySafetySkills"
                    label="Deficits in community safety skills"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SkillDeftPlaySkills"
                    label="Deficits in play skills"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SkillDeftOther"
                    label="Other"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorSkillDeftOther &&
                (<div className='col-sm-4 require'>
                  <Field
                    name="SkillDeftOtherNotes"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={this.state.isSoapCompleted}
                    component={renderTextField}
                  />
                </div>)}
                </div>

              <div className="row mt-35">               
                <div className="col-sm-12"><h6><strong>Techniques to increase target behaviors</strong></h6></div>            
              </div>
              <div className="row">
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="TechBehSampling"
                    label="Sampling/Preference Assessment/Pairing"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="TechBehBehavioralSkillsTraining"
                    label="Behavioral skills training"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="TechBehDTT"
                    label="DTT"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="TechBehShaping"
                    label="Chaining/Shaping"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="TechBehErrorlessTeaching"
                    label="Errorless Teaching"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="TechBehSystematicPromptFading"
                    label="Systematic prompt fading"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="TechBehNET"
                    label="NET"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>                
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="TechBehOther"
                    label="Other"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorTechBehOther &&
                (<div className='col-sm-4 require'>
                  <Field
                    name="TechBehOtherNotes"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={this.state.isSoapCompleted}
                    component={renderTextField}
                  />
                </div>)}
              </div>

              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Progress towards treatment goals</h5><span style={{ color: 'red' }}>*</span>
                    {!this.state.isTreatmentGoalsAllowed && <div style={{ color: 'red', marginLeft: '20px'}}>(Please select at least one)</div>}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className='col-sm-4 require'>
                  <Field
                    name="SessionComments1"
                    type="text"
                    fullWidth={true}
                    label="Programs observed during session"
                    disabled={this.state.isSoapCompleted}
                    component={renderTextField}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SessionMastery1"
                    label="Session mastery"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ContinueTeaching1"
                    label="Continue teaching"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Generalized1"
                    label="Generalized"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Hold1"
                    label="Hold/discontinue"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="DevelopProtocol1"
                    label="Develop/edit protocol"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>                
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherTG1"
                    label="Other"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOtherTG1 &&
                (<div className='col-sm-4 require'>
                  <Field
                    name="OtherTGNotes1"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={this.state.isSoapCompleted}
                    component={renderTextField}
                  />
                </div>)}
              </div>

              <div className="row">
                <div className='col-sm-4 require'>
                  <Field
                    name="SessionComments2"
                    type="text"
                    fullWidth={true}
                    label="Programs observed during session"
                    disabled={this.state.isSoapCompleted}
                    component={renderTextField}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SessionMastery2"
                    label="Session mastery"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ContinueTeaching2"
                    label="Continue teaching"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Generalized2"
                    label="Generalized"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Hold2"
                    label="Hold/discontinue"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="DevelopProtocol2"
                    label="Develop/edit protocol"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>                
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherTG2"
                    label="Other"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOtherTG2 &&
                (<div className='col-sm-4 require'>
                  <Field
                    name="OtherTGNotes2"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={this.state.isSoapCompleted}
                    component={renderTextField}
                  />
                </div>)}
              </div>

              <div className="row">
                <div className='col-sm-4 require'>
                  <Field
                    name="SessionComments3"
                    type="text"
                    fullWidth={true}
                    label="Programs observed during session"
                    disabled={this.state.isSoapCompleted}
                    component={renderTextField}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="SessionMastery3"
                    label="Session mastery"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ContinueTeaching3"
                    label="Continue teaching"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Generalized3"
                    label="Generalized"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Hold3"
                    label="Hold/discontinue"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="DevelopProtocol3"
                    label="Develop/edit protocol"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>                
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherTG3"
                    label="Other"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOtherTG3 &&
                (<div className='col-sm-4 require'>
                  <Field
                    name="OtherTGNotes3"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={this.state.isSoapCompleted}
                    component={renderTextField}
                  />
                </div>)}
              </div>


              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Generalization/Maintenance</h5><span style={{ color: 'red' }}>*</span>
                    {!this.state.isGeneralizationAllowed && <div style={{ color: 'red', marginLeft: '20px'}}>(Please select at least one)</div>}
                  </div>
                </div>
              </div>
              <div className="row mt-35">               
                <div className="col-sm-12"><h6><strong>Generalization and Maintenance Checks</strong></h6></div>            
              </div>
              <div className="row">                
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="GenReceptiveLanguage"
                    label="Receptive Language"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="GenPlay"
                    label="Play"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="GenExpressiveLanguage"
                    label="Expressive Language"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="GenFCT"
                    label="FCT"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="GenImitation"
                    label="Imitation"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>     
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="GenAdaptiveBehavior"
                    label="Adaptive Behavior"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>                
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="GenOther"
                    label="Other"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorGenOther &&
                (<div className='col-sm-4 require'>
                  <Field
                    name="GenOtherNotes"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={this.state.isSoapCompleted}
                    component={renderTextField}
                  />
                </div>)}
              </div>
              
              <div className="row">
                <div className='col-sm-4 require'>
                  <Field
                    name="TotalNumberOfTrials"
                    type="text"
                    fullWidth={true}
                    label="Total # of trials/session"
                    maxLength='14'
                    disabled={this.state.isSoapCompleted}
                    component={renderTextField}
                    normalize={isInteger}
                  />
                </div>
              </div>

              <div className="row mt-35">               
                <div className="col-sm-12"><h6><strong>Progress</strong></h6></div>            
              </div>   
              <div className="row">                
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ProgressAllTargets"
                    label="All targets maintained at 80% or above"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ProgressMostTargets"
                    label="Most targets maintained at 80% or above"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ProgressMultipleTargets"
                    label="Multiple targets did not maintain at 80% or above"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>                       
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ProgressOtherTargets"
                    label="Other"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorProgressOtherTargets &&
                (<div className='col-sm-4 require'>
                  <Field
                    name="ProgressOtherTargetsNotes"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={this.state.isSoapCompleted}
                    component={renderTextField}
                  />
                </div>)}
              </div>
              
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Summary of Maladaptive Behaviors </h5><span style={{ color: 'red' }}>*</span>
                    {!this.state.isBehaviorReductionAllowed && <div style={{ color: 'red', marginLeft: '20px'}}>(Please select at least one)</div>}
                  </div>
                </div>
              </div>
              <div className="row mt-35">               
                <div className="col-sm-12"><h6><strong>Behavior Reduction Techniques</strong></h6></div>            
              </div>   
              <div className="row">                
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="DifferentialReinforcement"
                    label="Differential reinforcement"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Extinction"
                    label="Extinction"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="BehavioralMomentum"
                    label="Behavioral momentum"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="FCT"
                    label="FCT"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Assessment"
                    label="Assessment/Observation"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>     
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OperantReinforcement"
                    label="Operant reinforcement"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>    
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="AntecedentManipulations"
                    label="Antecedent manipulations"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="TaskAnalysis"
                    label="Task Analysis"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="PositiveReinforcement"
                    label="Positive reinforcement"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>     
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="Punishment"
                    label="Punishment"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>                
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherBR"
                    label="Other"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOtherBR &&
                (<div className='col-sm-4 require'>
                  <Field
                    name="OtherBRNotes"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={this.state.isSoapCompleted}
                    component={renderTextField}
                  />
                </div>)}
              </div>

              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>Protocol Modification by BCBA/BCaBA (only)</h5>{this.props.hasBCBARole && <span style={{ color: 'red' }}>*</span>}
                    {this.props.hasBCBARole && !this.state.isProtocolModificationAllowed && <div style={{ color: 'red', marginLeft: '20px'}}>(Please select at least one)</div>}
                  </div>
                </div>
              </div>
              <div className="row">                
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="DataAnalysis"
                    label="Data Analysis/graphing"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="UpdatedBIP"
                    label="Updated BIP"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="AssessmentPM"
                    label="Assessment/FBA"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ModificationsToCurrentProgramming"
                    label="Modifications to current programming"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="DevelopNewProgramming"
                    label="Develop new programming"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>                            
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherPM"
                    label="Other"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOtherPM &&
                (<div className='col-sm-4 require'>
                  <Field
                    name="OtherPMNotes"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={this.state.isSoapCompleted}
                    component={renderTextField}
                  />
                </div>)}
              </div>
              
              <div className="row">
                <div className="col-sm-12">
                  <div className="panel_title">
                    <h5>BT Guidance by BCBA/BCaBA (only)</h5>{this.props.hasBCBARole && <span style={{ color: 'red' }}>*</span>}
                    {this.props.hasBCBARole && !this.state.isBTGuidanceAllowed && <div style={{ color: 'red', marginLeft: '20px'}}>(Please select at least one)</div>}
                  </div>
                </div>
              </div>
              <div className="row">                
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="AccuracyOfDataCollection"
                    label="Accuracy of data collection"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="EffectivelyImplementsDTT"
                    label="Effectively implements DTT"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="EffectivelyImplementsClientBIP"
                    label="Effectively implements client BIP"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="EffectivelyImplementsErrorCorrection"
                    label="Effectively implements Error Correction"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="EffectivelyImplementsSystematicPromptFading"
                    label="Effectively implements systematic prompt fading"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>     
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="EffectivelyEstablishesInstructionalControl"
                    label="Effectively establishes instructional control"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>     
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="ImplementsReinforcementProceduresEffectively"
                    label="Implements reinforcement procedures effectively"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>                            
                <div className='col-sm-4 mt-35'>
                  <Field
                    name="OtherBT"
                    label="Other"
                    disabled={this.state.isSoapCompleted}
                    component={renderCheckBox}
                  />
                </div>
                {this.props.selectorOtherBT &&
                (<div className='col-sm-4 require'>
                  <Field
                    name="OtherBTNotes"
                    type="text"
                    fullWidth={true}
                    label="Other Notes"
                    disabled={this.state.isSoapCompleted}
                    component={renderTextField}
                  />
                </div>)}
              </div>
              
              <div className="row mt-35">
                <div className='col-sm-12 require'>
                  <Field
                    name="notes"
                    type="text"
                    fullWidth={true}
                    label="Summary Statement"
                    // autoHeight={true}
                    rows={8}
                    disabled={this.state.isSoapCompleted}
                    component={renderTextArea}
                  />
                </div>
              </div>
            
            </form>
            <div className="row">
              <div className="col-sm-12">
                <div className="panel_title mt-24  mb-20">
                  <h3>Diagnosis</h3>
                  <i className="flaticon flaticon-gym"></i>
                </div>
              </div>
              {/* {this.props.addPermission && !this.state.isSoapCompleted ?
                <div className="col-sm-12 pdl-30">
                  <CommonButton className="soapmodal_btn" label="Add Diagnosis" primary={true} onTouchTap={this.handleOpen} />
                </div>
                : null} */}
            </div>
            <div className="table-responsive mt-15">
              <Table className={tableClass1}
                height={this.state.height}
                fixedHeader={this.state.fixedHeader}
                fixedFooter={this.state.fixedFooter}
                selectable={this.state.selectable}
                multiSelectable={this.state.multiSelectable}
              >
                <TableHeader
                  displaySelectAll={false}
                  adjustForCheckbox={false}
                >
                  <TableRow>
                    <TableHeaderColumn width="30%">Diagnosis Code</TableHeaderColumn>
                    <TableHeaderColumn width="70%">Description</TableHeaderColumn>
                    {/* {!this.state.isSoapCompleted ?
                      <TableHeaderColumn>Action</TableHeaderColumn>
                      : null} */}
                    {/* <TableHeaderColumn width="20%">Attach</TableHeaderColumn>*/}
                  </TableRow>
                </TableHeader>
                <TableBody
                  displayRowCheckbox={false}
                  deselectOnClickaway={this.state.deselectOnClickaway}
                  showRowHover={this.state.showRowHover}
                  stripedRows={this.state.stripedRows}
                >
                  {this.renderDiagnosis()}
                </TableBody>
              </Table>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="panel_title mt-24  mb-20">
                  <h3>Service Codes</h3>
                  <i className="flaticon flaticon-interface-2"></i>
                </div>
              </div>
              {/* {this.props.addPermission && !this.state.isSoapCompleted ?
                <div className="col-sm-12 pdl-30">
                  <RaisedButton className="soapmodal_btn" label="Add Service Codes" primary={true} onTouchTap={this.handleOpenCPT} />
                </div>
                : null} */}
            </div>
            <div className="mt-15">
              <Table className={tableClass1}
                height={this.state.height}
                fixedHeader={this.state.fixedHeader}
                fixedFooter={this.state.fixedFooter}
                selectable={this.state.selectable}
                multiSelectable={this.state.multiSelectable}
              >
                <TableHeader
                  displaySelectAll={false}
                  adjustForCheckbox={false}
                >
                  <TableRow>
                    <TableHeaderColumn>Service Code</TableHeaderColumn>
                    <TableHeaderColumn>Modifiers</TableHeaderColumn>
                    <TableHeaderColumn>Description</TableHeaderColumn>
                    {/* {this.props.deletePermission && !this.state.isSoapCompleted ?
                      <TableHeaderColumn width="10%">Action</TableHeaderColumn>
                      : null} */}
                  </TableRow>
                </TableHeader>
                <TableBody
                  displayRowCheckbox={false}
                  deselectOnClickaway={this.state.deselectOnClickaway}
                  showRowHover={this.state.showRowHover}
                  stripedRows={this.state.stripedRows}
                >
                  {this.renderCpt()}
                </TableBody>
              </Table>
            </div>
            <div className="row">
              <div className={`col-sm-12 pt20 btn_rt ${this.state.showCompleteButton && 'scroll_btn'}`}>
                <CancelButton onTouchTap={this.handleCancel} />
                {this.state.showCompleteButton && canOnlyAddSignForTheirNotes ?
                  <CommonButton className="soapmodal_btn ml-3" label="Add Sign" primary={true} onTouchTap={this.handleOpenSign} />
                  : ''}

                {!this.state.isSoapCompleted ?
                  (<span>
                    {this.state.showCompleteButton ?
                      <CommonButton id="btnComplete" className="ml-3 soapmodal_btn" label="Complete" primary={true} disabled={!this.state.isAllSigned} onClick={handleSubmit(this.onCompleteSoap)} />
                      : <CommonButton onClick={handleSubmit(this.onSubmit)} className="ml-3" primary={true} label="Save" />
                    }
                  </span>)
                  : ''}
              </div>
            </div>

            {this.state.EmployeeSign.Bytes || this.state.ClientSign.Bytes || this.state.GuardianSign.Bytes || this.state.RenderingProviderSign.Bytes ?
              <div className="row">
                <div className="col-12">
                  <div className="panel_title mt-24  mb-20">
                    <h3>Signature</h3>
                    <i className="flaticon flaticon-medical-1"></i>
                  </div>
                </div>
                {
                  this.state.EmployeeSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageEmployee">

                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.EmployeeSign.Bytes}`} alt={''} />
                              <h3>{this.state.EmployeeSign.Name} <span>(Employee)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.EmployeeSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.EmployeeSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.EmployeeSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    : ''
                }
                {
                  this.state.ClientSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageClient">

                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.ClientSign.Bytes}`} alt={''} />
                              <h3>{this.state.ClientSign.Name ? this.state.ClientSign.Name : this.state.patientName} <span>(Client)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.ClientSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.ClientSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.ClientSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    : ''
                }
                {
                  this.state.GuardianSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageGuadian">

                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.GuardianSign.Bytes}`} alt={''} />
                              <h3>{this.state.GuardianSign.Name} <span>(Guardian)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.GuardianSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.GuardianSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.GuardianSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                    : ''
                }
                {
                  this.state.RenderingProviderSign.Bytes ?
                    <div className="col-sm-12 col-md-4">
                      <div id="showCanvasImageEmployee">

                        <div className="row">
                          <div className="col-12">
                            <div className="sign">
                              <img className="img-fluid" src={`data:image/png;base64,${this.state.RenderingProviderSign.Bytes}`} alt={''} />
                              <h3>{this.state.RenderingProviderSign.Name} <span>(Supervising Clinician)</span></h3>
                              <p><span>Date :</span> {showFormatedDateandTime(this.state.RenderingProviderSign.Date)}</p>
                              {/* <p><span>Latitude :</span> {this.state.RenderingProviderSign.Latitude}</p>
                              <p><span>Longitude :</span> {this.state.RenderingProviderSign.Longitude}</p> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    : ''
                }
              </div>
              : ''}

          </div>
        </div>
      </div>
    );
  }
};
const selector = formValueSelector('soapForm');
ProgressNotes_CAS = reduxForm({
  form: 'soapForm',
  validate,
  enableReinitialize: true,
})(ProgressNotes_CAS);

function mapStateToProps(state) {
  // Start For Role Permission
  let userActionPermission = [];
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'SCHEDULING');
    let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === 'SCHEDULING_LIST' && obj.moduleId === userModulePermission[0].moduleId);
    userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }

  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

  let hasBCBARole = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'BCBA' ? true : false; // For Role Permission

  let addPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_ADDCODES_IN_SOAP')[0].permission : false;
  let deletePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_DELETECODES_IN_SOAP')[0].permission : false;
  let modifyAfterRenderPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_MODIFYAPPOINTMENT_AFTER_RENDERING')[0].permission : false;
  let requiredGuardianSignForIndirectServicePermission = hasDefaultAccess ? false : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_REQUIRED_GUARDIAN_SIGNATURE_FOR_INDIRECT_SERVICE')[0].permission : false;
  let canOnlyAddSignForTheirNotes = hasDefaultAccess ? false : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'SCHEDULING_LIST_PRACTITIONER_CAN_ONLY_ADD_SIGN_FOR_THEIR_OWN_NOTES')[0].permission : false;
  // End For Role Permission

  let app_config = state.appConfig.appConfigList ? state.appConfig.appConfigList.data : null;
  let initialData = null;
  if (state.soap.get_soap) {
    let obj = state.soap.get_soap.data;
    if (obj.progressNotes_CAS) {
      
      initialData = {
        
        notes: obj.progressNotes_CAS.notes,
        // progressNote_ParentReport_CAS
        Happy: obj.progressNotes_CAS.progressNote_ParentReport_CAS.happy,
        Tired: obj.progressNotes_CAS.progressNote_ParentReport_CAS.tired,
        Sick: obj.progressNotes_CAS.progressNote_ParentReport_CAS.sick,
        Wellrested: obj.progressNotes_CAS.progressNote_ParentReport_CAS.wellrested,
        Sensorysicking: obj.progressNotes_CAS.progressNote_ParentReport_CAS.sensorysicking,
        Upset: obj.progressNotes_CAS.progressNote_ParentReport_CAS.upset,
        OtherPN: obj.progressNotes_CAS.progressNote_ParentReport_CAS.otherPN,
        OtherPNNotes: obj.progressNotes_CAS.progressNote_ParentReport_CAS.otherPNNotes,

        IsWarrantTherapy: obj.progressNotes_CAS.progressNote_ParentReport_CAS.isWarrantTherapy === true ? 1 : 0,

        // ProgressNote_SymptomsObserved_CAS
        SkillDeftReceptiveLanguage: obj.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftReceptiveLanguage,
        SkillDeftAdaptiveBehavior: obj.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftAdaptiveBehavior,
        SkillDeftExpressiveLanguage: obj.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftExpressiveLanguage,
        SkillDeftImitationSkills: obj.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftImitationSkills,
        SkillDeftSocialSkills: obj.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftSocialSkills,
        SkillDeftCommunitySafetySkills: obj.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftCommunitySafetySkills,
        SkillDeftPlaySkills: obj.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftPlaySkills,
        SkillDeftOther: obj.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftOther,
        SkillDeftOtherNotes: obj.progressNotes_CAS.progressNote_SymptomsObserved_CAS.skillDeftOtherNotes,

        TechBehSampling: obj.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehSampling,
        TechBehBehavioralSkillsTraining: obj.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehBehavioralSkillsTraining,
        TechBehDTT: obj.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehDTT,
        TechBehShaping: obj.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehShaping,
        TechBehErrorlessTeaching: obj.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehErrorlessTeaching,
        TechBehSystematicPromptFading: obj.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehSystematicPromptFading,
        TechBehNET: obj.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehNET,
        TechBehOther: obj.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehOther,
        TechBehOtherNotes: obj.progressNotes_CAS.progressNote_SymptomsObserved_CAS.techBehOtherNotes,

        // ProgressNote_TreatmentGoals_CAS
        SessionComments1: obj.progressNotes_CAS.progressNote_TreatmentGoals_CAS.sessionComments1,
        SessionMastery1: obj.progressNotes_CAS.progressNote_TreatmentGoals_CAS.sessionMastery1,
        ContinueTeaching1: obj.progressNotes_CAS.progressNote_TreatmentGoals_CAS.continueTeaching1,
        Generalized1: obj.progressNotes_CAS.progressNote_TreatmentGoals_CAS.generalized1,
        Hold1: obj.progressNotes_CAS.progressNote_TreatmentGoals_CAS.hold1,
        DevelopProtocol1: obj.progressNotes_CAS.progressNote_TreatmentGoals_CAS.developProtocol1,      
        OtherTG1: obj.progressNotes_CAS.progressNote_TreatmentGoals_CAS.otherTG1,
        OtherTGNotes1: obj.progressNotes_CAS.progressNote_TreatmentGoals_CAS.otherTGNotes1,

        SessionComments2: obj.progressNotes_CAS.progressNote_TreatmentGoals_CAS.sessionComments2,
        SessionMastery2: obj.progressNotes_CAS.progressNote_TreatmentGoals_CAS.sessionMastery2,
        ContinueTeaching2: obj.progressNotes_CAS.progressNote_TreatmentGoals_CAS.continueTeaching2,
        Generalized2: obj.progressNotes_CAS.progressNote_TreatmentGoals_CAS.generalized2,
        Hold2: obj.progressNotes_CAS.progressNote_TreatmentGoals_CAS.hold2,
        DevelopProtocol2: obj.progressNotes_CAS.progressNote_TreatmentGoals_CAS.developProtocol2,      
        OtherTG2: obj.progressNotes_CAS.progressNote_TreatmentGoals_CAS.otherTG2,
        OtherTGNotes2: obj.progressNotes_CAS.progressNote_TreatmentGoals_CAS.otherTGNotes2,

        SessionComments3: obj.progressNotes_CAS.progressNote_TreatmentGoals_CAS.sessionComments3,
        SessionMastery3: obj.progressNotes_CAS.progressNote_TreatmentGoals_CAS.sessionMastery3,
        ContinueTeaching3: obj.progressNotes_CAS.progressNote_TreatmentGoals_CAS.continueTeaching3,
        Generalized3: obj.progressNotes_CAS.progressNote_TreatmentGoals_CAS.generalized3,
        Hold3: obj.progressNotes_CAS.progressNote_TreatmentGoals_CAS.hold3,
        DevelopProtocol3: obj.progressNotes_CAS.progressNote_TreatmentGoals_CAS.developProtocol3,      
        OtherTG3: obj.progressNotes_CAS.progressNote_TreatmentGoals_CAS.otherTG3,
        OtherTGNotes3: obj.progressNotes_CAS.progressNote_TreatmentGoals_CAS.otherTGNotes3,
        

        // ProgressNote_Generalization_CAS
        GenReceptiveLanguage: obj.progressNotes_CAS.progressNote_Generalization_CAS.genReceptiveLanguage,
        GenPlay: obj.progressNotes_CAS.progressNote_Generalization_CAS.genPlay,
        GenExpressiveLanguage: obj.progressNotes_CAS.progressNote_Generalization_CAS.genExpressiveLanguage,
        GenFCT: obj.progressNotes_CAS.progressNote_Generalization_CAS.genFCT,
        GenImitation: obj.progressNotes_CAS.progressNote_Generalization_CAS.genImitation,
        GenAdaptiveBehavior: obj.progressNotes_CAS.progressNote_Generalization_CAS.genAdaptiveBehavior,      
        GenOther: obj.progressNotes_CAS.progressNote_Generalization_CAS.genOther,
        GenOtherNotes: obj.progressNotes_CAS.progressNote_Generalization_CAS.genOtherNotes,

        ProgressAllTargets: obj.progressNotes_CAS.progressNote_Generalization_CAS.progressAllTargets,
        ProgressMostTargets: obj.progressNotes_CAS.progressNote_Generalization_CAS.progressMostTargets,
        ProgressMultipleTargets: obj.progressNotes_CAS.progressNote_Generalization_CAS.progressMultipleTargets,        
        ProgressOtherTargets: obj.progressNotes_CAS.progressNote_Generalization_CAS.progressOtherTargets,
        ProgressOtherTargetsNotes: obj.progressNotes_CAS.progressNote_Generalization_CAS.progressOtherTargetsNotes,

        TotalNumberOfTrials: obj.progressNotes_CAS.progressNote_Generalization_CAS.totalNumberOfTrials,

         // ProgressNote_BehaviorReduction_CAS
         DifferentialReinforcement: obj.progressNotes_CAS.progressNote_BehaviorReduction_CAS.differentialReinforcement,
         Extinction: obj.progressNotes_CAS.progressNote_BehaviorReduction_CAS.extinction,
         BehavioralMomentum: obj.progressNotes_CAS.progressNote_BehaviorReduction_CAS.behavioralMomentum,
         FCT: obj.progressNotes_CAS.progressNote_BehaviorReduction_CAS.fct,
         Assessment: obj.progressNotes_CAS.progressNote_BehaviorReduction_CAS.assessment,
         OperantReinforcement: obj.progressNotes_CAS.progressNote_BehaviorReduction_CAS.operantReinforcement,          
         AntecedentManipulations: obj.progressNotes_CAS.progressNote_BehaviorReduction_CAS.antecedentManipulations,
         TaskAnalysis: obj.progressNotes_CAS.progressNote_BehaviorReduction_CAS.taskAnalysis,
         PositiveReinforcement: obj.progressNotes_CAS.progressNote_BehaviorReduction_CAS.positiveReinforcement,
         Punishment: obj.progressNotes_CAS.progressNote_BehaviorReduction_CAS.punishment, 
         OtherBR: obj.progressNotes_CAS.progressNote_BehaviorReduction_CAS.otherBR,
         OtherBRNotes: obj.progressNotes_CAS.progressNote_BehaviorReduction_CAS.otherBRNotes,

         // ProgressNote_ProtocolModification_CAS
         DataAnalysis: obj.progressNotes_CAS.progressNote_ProtocolModification_CAS.dataAnalysis,
         UpdatedBIP: obj.progressNotes_CAS.progressNote_ProtocolModification_CAS.updatedBIP,
         AssessmentPM: obj.progressNotes_CAS.progressNote_ProtocolModification_CAS.assessmentPM,
         ModificationsToCurrentProgramming: obj.progressNotes_CAS.progressNote_ProtocolModification_CAS.modificationsToCurrentProgramming,
         DevelopNewProgramming: obj.progressNotes_CAS.progressNote_ProtocolModification_CAS.developNewProgramming,         
         OtherPM: obj.progressNotes_CAS.progressNote_ProtocolModification_CAS.otherPM,
         OtherPMNotes: obj.progressNotes_CAS.progressNote_ProtocolModification_CAS.otherPMNotes,


         // ProgressNote_BTGuidance_CAS
         AccuracyOfDataCollection: obj.progressNotes_CAS.progressNote_BTGuidance_CAS.accuracyOfDataCollection,
         EffectivelyImplementsDTT: obj.progressNotes_CAS.progressNote_BTGuidance_CAS.effectivelyImplementsDTT,
         EffectivelyImplementsClientBIP: obj.progressNotes_CAS.progressNote_BTGuidance_CAS.effectivelyImplementsClientBIP,
         EffectivelyImplementsErrorCorrection: obj.progressNotes_CAS.progressNote_BTGuidance_CAS.effectivelyImplementsErrorCorrection,
         EffectivelyImplementsSystematicPromptFading: obj.progressNotes_CAS.progressNote_BTGuidance_CAS.effectivelyImplementsSystematicPromptFading,  
         EffectivelyEstablishesInstructionalControl: obj.progressNotes_CAS.progressNote_BTGuidance_CAS.effectivelyEstablishesInstructionalControl,
         ImplementsReinforcementProceduresEffectively: obj.progressNotes_CAS.progressNote_BTGuidance_CAS.implementsReinforcementProceduresEffectively,
         OtherBT: obj.progressNotes_CAS.progressNote_BTGuidance_CAS.otherBT,
         OtherBTNotes: obj.progressNotes_CAS.progressNote_BTGuidance_CAS.otherBTNotes,
      };
    }
  }

  return {
    selectorOtherPN: selector(state, 'OtherPN'),
    selectorSkillDeftOther: selector(state, 'SkillDeftOther'),
    selectorTechBehOther: selector(state, 'TechBehOther'),
    selectorOtherTG1: selector(state, 'OtherTG1'),
    selectorOtherTG2: selector(state, 'OtherTG2'),
    selectorOtherTG3: selector(state, 'OtherTG3'),    
    selectorGenOther: selector(state, 'GenOther'),
    selectorProgressOtherTargets: selector(state, 'ProgressOtherTargets'),
    selectorOtherBR: selector(state, 'OtherBR'),
    selectorOtherPM: selector(state, 'OtherPM'),
    selectorOtherBT: selector(state, 'OtherBT'),

    app_config: app_config,
    userLocationList: state.login.userLocationList,
    master_data: state.soap.master_data,
    patientData: state.patient.get_patient_byid,
    patientPrimaryDiagnosis: state.patient.patientPrimaryDiagnosis,

    loading: state.soap.loading,
    appointment: state.soap.appointment,
    get_soap: state.soap.get_soap,
    saved_soap: state.soap.saved_soap && state.soap.saved_soap.data ? state.soap.saved_soap.data : null,
    initialValues: initialData,
    currentLoginUserId: state.login.loginUserInfo && state.login.loginUserInfo.id,
    hasDefaultAccess: hasDefaultAccess, // for Role Permissions
    addPermission: addPermission, // for Role Permissions
    deletePermission: deletePermission, // for Role Permissions
    modifyAfterRenderPermission: modifyAfterRenderPermission, // for Role Permissions
    requiredGuardianSignForIndirectServicePermission: requiredGuardianSignForIndirectServicePermission, // for Role Permissions
    canOnlyAddSignForTheirNotes: canOnlyAddSignForTheirNotes,
    latitude: state.appConfig.latitude,
    longitude: state.appConfig.longitude,
    hasBCBARole: hasBCBARole, // for Role Permissions
    IsWarrantTherapy: state.soap.get_soap && state.soap.get_soap.data && state.soap.get_soap.data.progressNotes_CAS ? state.soap.get_soap.data.progressNotes_CAS.progressNote_ParentReport_CAS.isWarrantTherapy === true ? 1 : 0 : null,
    clockInLatitude: state.appConfig.clockInLatitude,
    clockInLongitude: state.appConfig.clockInLongitude,
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
  };
}

export default connect(mapStateToProps, { getMasterData, getSoapAction, createClaimAction, getAppointmentById, savePatientSoapAction, updateServiceCodeBlockedUnits, getAppConfigList, getPatientProfileDetails, saveEncounterSigns, getGeoLocation, saveClockInTimeIntoAppointment, getGeoLocationClockIn })(ProgressNotes_CAS);



// WEBPACK FOOTER //
// ./src/modules/scheduling/components/ProgressNotes_CAS/index.js